import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconDocumentList: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 7.70833H14.7917V5C14.7917 2.985 13.6817 1.875 11.6667 1.875H5C2.985 1.875 1.875 2.985 1.875 5V15C1.875 17.015 2.985 18.125 5 18.125H15.8333C17.0975 18.125 18.125 17.0975 18.125 15.8333V9.58333C18.125 8.54917 17.2833 7.70833 16.25 7.70833ZM5 16.875C3.68583 16.875 3.125 16.3142 3.125 15V5C3.125 3.68583 3.68583 3.125 5 3.125H11.6667C12.9808 3.125 13.5417 3.68583 13.5417 5V15.8333C13.5417 16.2083 13.6317 16.5625 13.7925 16.875H5ZM16.875 15.8333C16.875 16.4075 16.4075 16.875 15.8333 16.875C15.2592 16.875 14.7917 16.4075 14.7917 15.8333V8.95833H16.25C16.5942 8.95833 16.875 9.23833 16.875 9.58333V15.8333ZM11.875 6.66667C11.875 7.01167 11.595 7.29167 11.25 7.29167H7.5C7.155 7.29167 6.875 7.01167 6.875 6.66667C6.875 6.32167 7.155 6.04167 7.5 6.04167H11.25C11.595 6.04167 11.875 6.32167 11.875 6.66667ZM11.875 10C11.875 10.345 11.595 10.625 11.25 10.625H7.5C7.155 10.625 6.875 10.345 6.875 10C6.875 9.655 7.155 9.375 7.5 9.375H11.25C11.595 9.375 11.875 9.655 11.875 10ZM11.875 13.3333C11.875 13.6783 11.595 13.9583 11.25 13.9583H7.5C7.155 13.9583 6.875 13.6783 6.875 13.3333C6.875 12.9883 7.155 12.7083 7.5 12.7083H11.25C11.595 12.7083 11.875 12.9883 11.875 13.3333ZM6.04167 6.66667C6.04167 7.01167 5.76167 7.29167 5.41667 7.29167C5.07167 7.29167 4.79167 7.01167 4.79167 6.66667C4.79167 6.32167 5.07167 6.04167 5.41667 6.04167C5.76167 6.04167 6.04167 6.32167 6.04167 6.66667ZM6.04167 10C6.04167 10.345 5.76167 10.625 5.41667 10.625C5.07167 10.625 4.79167 10.345 4.79167 10C4.79167 9.655 5.07167 9.375 5.41667 9.375C5.76167 9.375 6.04167 9.655 6.04167 10ZM6.04167 13.3333C6.04167 13.6783 5.76167 13.9583 5.41667 13.9583C5.07167 13.9583 4.79167 13.6783 4.79167 13.3333C4.79167 12.9883 5.07167 12.7083 5.41667 12.7083C5.76167 12.7083 6.04167 12.9883 6.04167 13.3333Z"
      fill={color}
    />
  </svg>
);

export default IconDocumentList;
